import { render, staticRenderFns } from "./newRegister.vue?vue&type=template&id=034f0bd1&scoped=true"
import script from "./newRegister.vue?vue&type=script&lang=js"
export * from "./newRegister.vue?vue&type=script&lang=js"
import style0 from "./newRegister.vue?vue&type=style&index=0&id=034f0bd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034f0bd1",
  null
  
)

export default component.exports